type DispensaryWithStoreSettings = {
  storeSettings?: {
    hideCategoryTiles?: boolean | null;
  } | null;
};

export function useHideCategoryTiles(dispensary?: DispensaryWithStoreSettings | null): boolean {
  return dispensary?.storeSettings?.hideCategoryTiles ?? false;
}
